import { useTranslation } from '@lt/localization';
import React from 'react';
import FlightsLuggage from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Flights/Luggage/FlightsLuggage/FlightsLuggage';
import { formatDateToDay, getHours } from 'src/utils/dateUtils';
import styled from 'styled-components';
import {
  TEST_ID_MOBILE_SUMMARY_FLIGHTS_DAYS_DIFF_BACK,
  TEST_ID_MOBILE_SUMMARY_FLIGHTS_DAYS_DIFF_TO,
} from '../constants';
import type { FlightInfo } from '../FlightsTime';

type Props = {
  isFlightChangable: boolean;
  direction: FlightInfo;
  daysDiff: number;
  className?: string;
  isDirectionBack?: boolean;
};

const FlightsOneWayInfo = (props: Props) => {
  const { isFlightChangable, direction, daysDiff, className, isDirectionBack } =
    props;
  const { t } = useTranslation();
  return (
    <StyledWrapper $isFlightChangable={isFlightChangable} className={className}>
      {isFlightChangable && <Date>{formatDateToDay(direction.date)}</Date>}
      <StyledInfoContainer $isFlightChangable={isFlightChangable}>
        <Luggage>
          <FlightsLuggage luggage={direction.luggage} isMobile />
        </Luggage>
        {!isFlightChangable && (
          <>
            <Time>
              {getHours(direction.departureTime)} -{' '}
              {getHours(direction.arrivalTime)}
              {daysDiff > 0 && (
                <DaysDiff
                  data-testid={
                    isDirectionBack
                      ? TEST_ID_MOBILE_SUMMARY_FLIGHTS_DAYS_DIFF_BACK
                      : TEST_ID_MOBILE_SUMMARY_FLIGHTS_DAYS_DIFF_TO
                  }
                >{`+${daysDiff}${t('checkout.flight.days')}`}</DaysDiff>
              )}
            </Time>
            <Date>{formatDateToDay(direction.date)}</Date>
          </>
        )}
      </StyledInfoContainer>
    </StyledWrapper>
  );
};
const StyledWrapper = styled.div<{
  $isFlightChangable: boolean;
}>`
  ${($isFlightChangable) =>
    $isFlightChangable &&
    `
      display: flex;
      align-items: center;
    `}
  flex: 1;
`;
const StyledInfoContainer = styled.div<{
  $isFlightChangable: boolean;
}>`
  display: flex;
  ${($isFlightChangable) => $isFlightChangable && `flex-direction: column;`}
`;
const Date = styled.div`
  color: #4d4d4d;
  padding: 6px 0px 2px 0px;
`;
const DaysDiff = styled.sup`
  font-weight: 400;
  font-size: 9px;
  line-height: 12px;
`;
const Luggage = styled.div``;
const Time = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;

  color: #17181a;
`;

export default FlightsOneWayInfo;
